export function renderPanelPlotLines(parentElem, panelLayout, panelIndex, plotLines, xScale) {

	const plotLinesGroupElem = parentElem.append('g')
		.attr('class', 'hw_panel_graph_plot_lines');

	plotLines.forEach(plotLine => {

		const x = xScale(plotLine.config.x);

		plotLinesGroupElem.append('line')
			.attr('class', `hw_panel_graph_plot_line_${plotLine.config.name}`)
			.attr('x1', x)
			.attr('x2', x)
			.attr('y1', panelLayout.y)
			.attr('y2', panelLayout.y + panelLayout.height);

		// Render the plot line label if this is the top panel and a label has been specified.
		if (plotLine.config.label !== null && panelIndex === 0) {
			plotLinesGroupElem.append('text')
				.attr('class', `hw_panel_graph_plot_line_label_${plotLine.config.name}`)
				.attr('x', x)
				.attr('y', panelLayout.y + 2)
				.attr('dy', '1em')
				.attr('text-anchor', 'middle')
				.text(plotLine.config.label);
		}

	});

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-panel-plot-lines.js